import { MESSAGE_TYPES } from '../constants/message.constants';
export const MessageParsers = {
    text: (message, sender) => ({
        sender,
        type: MESSAGE_TYPES.TEXT,
        text: message.text,
        timestamp: message.timestamp,
    }),
    image: ({ attachment, text, timestamp }, sender) => ({
        sender,
        type: MESSAGE_TYPES.IMAGE,
        imageSrc: attachment.payload.src,
        alt: attachment.payload.alt || '',
        text: text,
        timestamp: timestamp,
    }),
    accordion: (message, sender) => (Object.assign(Object.assign({ sender }, message), { type: MESSAGE_TYPES.ACCORDION })),
    carousel: ({ elements, timestamp }, sender) => ({
        sender,
        type: MESSAGE_TYPES.CAROUSEL,
        elements: elements.map(({ image_url, text, link }) => ({
            text,
            link,
            imageUrl: image_url,
        })),
        timestamp,
    }),
    quickReply: (message, sender) => ({
        sender,
        type: MESSAGE_TYPES.QUICK_REPLY,
        text: message.text,
        replies: message.quick_replies.map(({ title, payload, isSelected }) => ({
            text: title,
            reply: payload,
            isSelected,
        })),
        timestamp: message.timestamp,
    }),
    fileDownload: ({ text, file_url, file_name, timestamp }, sender) => ({
        sender,
        type: MESSAGE_TYPES.FILE_DOWNLOAD,
        fileName: file_name,
        fileUrl: file_url,
        text,
        timestamp,
    }),
    video: ({ title, video_url, timestamp }, sender) => ({
        sender,
        type: MESSAGE_TYPES.VIDEO,
        src: video_url,
        timestamp,
    }),
    rating: (message, sender) => ({
        sender,
        type: MESSAGE_TYPES.RATING,
        text: message.text,
        options: message.options.map(option => ({
            value: option.value,
            payload: option.payload
        })),
        message: message.message,
        timestamp: message.timestamp,
    }),
};
//# sourceMappingURL=message-parsers.js.map